<template>
  <div>
    <Head title="Inventaris - Asset Events" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      Asset Events
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Jenis Event (Mutasi)
            </th>
            <th class="pb-4 pt-6 px-6">
              Deskripsi
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="asset in assetEvents.data"
            :key="asset.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                tabindex="-1"
                href="#">
                {{ asset.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                tabindex="-1"
                href="#">
                {{ asset.desc }}
              </Link>
            </td>
          </tr>
          <tr v-if="assetEvents.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="11">
              No Asset Event found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="assetEvents.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { defineProps } from 'vue'
import { Head, Link } from '@inertiajs/vue3'
import Pagination from '@/Shared/Pagination.vue'

defineProps({
    assetEvents: Object,
})
</script>
